import { ProjectCard } from "@/components/spatialAnalysis/projectList/projectCard";
import TimeAgo from "@/components/ui/TimeAgo";
import { useConfirmationModal } from "@/hooks/ui/modal/useConfirmationModal";
import { AnalysisConfigurationItem } from "@/types/project";
import { AreaInputType, EOutputAnalysisType } from "@/types/spatial";

import { Button } from "equator-design-system";

type ProjectItemProps = {
  data: AnalysisConfigurationItem;
  onOpenProject: (data: AnalysisConfigurationItem) => void;
  onDeleteProject: (data: AnalysisConfigurationItem) => void;
};

const ProjectItem = ({
  data,
  onOpenProject,
  onDeleteProject
}: ProjectItemProps) => {
  const { showConfirmation } = useConfirmationModal();

  const isProfiling =
    data.analysis_output_type === EOutputAnalysisType.PROFILING;

  const gridType = () => {
    if (!data.area_input_type) return "-";
    return data.area_input_type === AreaInputType.ADMIN_AREA
      ? "Adm Area"
      : "Catchment";
  };

  const onDeleteItem = (data: AnalysisConfigurationItem) => {
    showConfirmation({
      title: "Are you sure, you want to delete? ",
      message: "Once deleted, this action cannot be undone.",
      cancelLabel: "",
      confirmLabel: "Delete",
      onConfirm: () => onDeleteProject(data)
    });
  };

  const getOutputText = () => {
    if (!data.analysis_output_type) return "-";
    return isProfiling ? "Profiling" : "Grid";
  };

  return (
    <ProjectCard
      className="w-full text-left rounded-lg h-auto btn-default group hover:bg-teal-50 hover:border-teal-200"
      title={data.name}
      subtitle={
        <>
          <TimeAgo date={data.updated_at} />
          {data.updated_by?.full_name && (
            <span> - by {data.updated_by.full_name}</span>
          )}
        </>
      }
      description={data.description}
      datasetCount={data.dataset_count}
      areaInputType={gridType()}
      outputType={getOutputText()}
      isProfiling={isProfiling}
      footer={
        <div className="hidden mt-3 w-full gap-2 group-hover:flex">
          <Button
            variant="secondary"
            className="w-1/2 h-8 text-sm font-semibold btn-secondary"
            onClick={() => onDeleteItem(data)}
          >
            Delete
          </Button>
          <Button
            className="w-1/2 h-8 text-sm font-semibold btn-primary"
            onClick={() => onOpenProject(data)}
            data-testid={`project-item-${data.id}`}
          >
            Open
          </Button>
        </div>
      }
    />
  );
};

export default ProjectItem;
